import { getSessionValue } from '@/fo/api/magento';
import { apiMindbox, MINDBOX_OPERATIONS } from '@/fo/api/mindbox';

const clearAll = async () => {
  const customerId = await getSessionValue('CUSTOMER_MINDBOX_ID');
  if (!customerId) {
    return;
  }

  return await apiMindbox(MINDBOX_OPERATIONS.FAVORITES_CLEAR, {
    customer: {
      ids: {
        bitrixClientId: customerId
      }
    }
  });
};

const update = async (
  items: { id: string; count: number; price: number }[]
) => {
  return await apiMindbox(MINDBOX_OPERATIONS.FAVORITES_CREATE, {
    productList: items.map(({ id, count, price }) => ({
      product: {
        ids: {
          bitrixProducts: id
        }
      },
      count,
      pricePerItem: price
    }))
  });
};

export const favoritesMindboxService = {
  clearAll,
  update
};
